import { Browser } from '@capacitor/browser'

/**
 * 通報フォームに遷移させる
 * https://docs.google.com/forms/d/e/1FAIpQLSeby6n5W6HKlYyuxUmfRzmehRCNDGDW7gYuPl76asK6dbMFoA/viewform
 *
 * @param email 通報者のメールアドレス
 * @param contentType 通報するコンテンツの種別
 * @param contentID 通報するコンテンツID
 * @param userId 通報対象者のID
 * @param accountId 通報対象者のアカウントID
 */

type openReportFormArgs = {
  email: string
  contentType: string
  contentId: string
  userId: string
  accountId: string
}

export const openReportForm = async ({
  email,
  contentType,
  contentId,
  userId,
  accountId,
}: openReportFormArgs) => {
  const url = [
    'https://docs.google.com/forms/d/e/1FAIpQLSdg1CL4rkdJi7Hz-PrVBr3kaP61760PxLucFcM_XOUXoj6S6w/viewform?usp=sharing',
    `137036600=${email}`,
    `666278690=${contentType}`,
    `581599158=${contentId}`,
    `1854267821=${userId}`,
    `384115263=${accountId}`,
  ].join('&entry.')

  await Browser.open({
    url,
  })
}
